<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs type="InertiaLink" :pages="meta.breadcrumbs" />
        </template>

        <div v-if="groups.length > 0" class="flex gap-4 flex-wrap">
            <div>
                <div>
                    {{ $tc('messages.groups', 2) }}
                </div>
                <div class="flex flex-wrap gap-x-2" v-auto-animate>
                    <AppButton
                        element="InertiaLink"
                        :href="group.url"
                        v-for="group in filteredGroups"
                        :key="group.id"
                        class="flex gap-x-2"
                    >
                        {{ group.text }}

                        <IconCircleCheckFilled class="h-5 w-5 text-indigo-600" v-if="filters.group_id == group.id" />
                    </AppButton>
                    <button @click="isGroupFilterActive = false" type="button" v-if="isGroupFilterActive">
                        <svg
                            class="w-10 h-10 text-indigo-300"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                    </button>
                </div>
            </div>
            <div v-if="filters.group_id">
                <div>
                    {{ $tc('messages.subject', 2) }}
                </div>
                <div class="flex flex-wrap gap-x-2">
                    <AppButton
                        element="InertiaLink"
                        :href="subject.url"
                        v-for="subject in subjects"
                        :key="subject.id"
                        class="flex gap-x-2"
                    >
                        {{ subject.text }}

                        <IconCircleCheckFilled
                            class="h-5 w-5 text-indigo-600"
                            v-if="filters.subject_id == subject.id"
                        />
                    </AppButton>
                </div>
            </div>
            <div v-if="filters.subject_id">
                <div>
                    {{ $tc('messages.sections', 1) }}
                </div>
                <div>
                    <label v-for="section in sections" :key="section.section">
                        <BadgePill :color="section.section === selectedSection ? 'indigo' : 'gray'">
                            {{ section.title }}
                            <input
                                type="radio"
                                name="section"
                                :id="section.section"
                                :value="section.section"
                                v-model="selectedSection"
                                class="sr-only"
                            />
                        </BadgePill>
                    </label>
                </div>
            </div>
        </div>
        <div v-else>
            <EmptyState picture>
                <template v-slot:picture />
            </EmptyState>
        </div>
        <template v-slot:pagination>
            <div v-if="filters.subject_id">
                <!--        Widgets section-->
                <DashboardTeacherWidgets :widgets="filteredWidgets" v-if="filteredWidgets.length > 0" />
                <EmptyState picture v-else>
                    <template v-slot:picture />
                </EmptyState>
            </div>
        </template>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import DashboardTeacherWidgets from '@/components/DashboardTeacherWidgets.vue';
import EmptyState from '@/components/EmptyState.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import SmartBreadcrumbs from '@/components/SmartBreadcrumbs.vue';
import { IconCircleCheckFilled } from '@tabler/icons-vue';
import AppButton from '@/components/AppButton.vue';
import BadgePill from '../../../../components/BadgePill.vue';

export default {
    components: {
        BadgePill,
        AppButton,
        IconCircleCheckFilled,
        SmartBreadcrumbs,
        PanelPage,
        EmptyState,
        DashboardTeacherWidgets,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'filters', 'groups', 'subjects', 'sections', 'widgets'],
    data() {
        return {
            selectedSection: this.filters.section,
            isGroupFilterActive: true,
        };
    },
    computed: {
        filteredWidgets: function () {
            return this.widgets.filter((w) => w.section === this.selectedSection);
        },
        filteredGroups: function () {
            if (!this.isGroupFilterActive) {
                return this.groups;
            }

            return this.groups.filter((g) => g.is_default);
        },
    },
};
</script>
